var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCompresiones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16286 19.513C12.0668 22.4337 20.6396 31.028 20.6396 31.028C20.6396 31.028 32.9221 18.7091 33.0629 18.5573H33.0647C34.3696 17.1246 35.1772 15.1542 35.1772 12.9784C35.1772 8.60887 31.9238 5.06647 27.9075 5.06647C23.8911 5.06647 20.6378 8.60887 20.6378 12.9784C20.6378 13.1963 20.6378 13.1963 20.6378 12.9784C20.6378 8.60887 17.3827 5.06647 13.3681 5.06647C9.35357 5.06647 6.10022 8.60887 6.10022 12.9784C6.10022 14.8827 6.7188 16.6297 7.74561 17.9945L9.16107 19.513H9.16286Z",
    fill: "#F5FBFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6378 12.9784C20.6378 8.60887 23.8911 5.06647 27.9075 5.06647C31.9238 5.06647 35.1772 8.60887 35.1772 12.9784C35.1772 15.1542 34.3696 17.1246 33.0647 18.5573H33.0629C32.9221 18.7091 20.6396 31.028 20.6396 31.028C20.6396 31.028 12.0668 22.4337 9.16286 19.513H9.16107L7.74561 17.9945C6.7188 16.6297 6.10022 14.8827 6.10022 12.9784C6.10022 8.60887 9.35357 5.06647 13.3681 5.06647C17.3827 5.06647 20.6378 8.60887 20.6378 12.9784ZM20.6378 12.9784C20.6378 13.1963 20.6378 13.1963 20.6378 12.9784Z",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4024 12.77V19.2429C22.2252 19.1691 22.0295 19.1285 21.8264 19.1285C20.9919 19.1285 20.3162 19.8042 20.3162 20.6387V19.8337C20.3162 19.398 20.1094 19.014 19.7955 18.7592V12.77C19.7955 12.05 20.3789 11.4666 21.099 11.4666C21.819 11.4666 22.4024 12.05 22.4024 12.77Z",
    fill: "#F9839A",
    stroke: "#228C80",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0443 25.8205C32.0443 26.5406 31.4608 27.124 30.7408 27.124H27.5616C27.5616 27.124 26.6421 27.2754 25.7892 27.7111V24.5171H30.7408C31.4608 24.5171 32.0443 25.1005 32.0443 25.8205Z",
    fill: "#F9839A",
    stroke: "#228C80",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0836 18.7523C17.7661 19.0034 17.5556 19.3911 17.5556 19.8342V20.9789C17.5556 20.1887 16.9131 19.5462 16.1229 19.5462C15.9457 19.5462 15.7832 19.5831 15.6281 19.6385L14.2434 14.7238C14.2102 14.6056 14.1954 14.4838 14.1954 14.3693C14.1954 13.797 14.5684 13.2763 15.1444 13.1176C15.8386 12.9219 16.5549 13.3243 16.7506 14.0185L18.0836 18.7523Z",
    fill: "#F9839A",
    stroke: "#228C80",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6861 23.2383V25.3836H13.1685C13.0466 25.3836 12.9285 25.3984 12.814 25.4243L10.5505 20.4209C10.2514 19.7637 10.5431 18.9919 11.2004 18.6965C11.8539 18.3975 12.6257 18.6892 12.9248 19.3464L14.6861 23.2383Z",
    fill: "#F9839A",
    stroke: "#228C80",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3702 17.4042L25.7891 22.4149V21.2961C25.7891 20.6204 25.2426 20.0739 24.5669 20.0739C24.3564 20.0739 24.1607 20.1293 23.9872 20.2253L26.0513 16.2116C26.3836 15.5691 27.1664 15.318 27.8089 15.6503C28.4477 15.9789 28.6988 16.7654 28.3702 17.4042Z",
    fill: "#F9839A",
    stroke: "#228C80",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7884 31.2929V19.7132C26.7884 19.0671 26.3194 18.4873 25.677 18.4283C25.4259 18.4061 25.1895 18.4615 24.9865 18.576C24.6024 18.7827 24.3403 19.1815 24.3403 19.6468V18.9895C24.3403 18.3581 23.9526 17.819 23.4024 17.5937C23.2251 17.5199 23.0294 17.4793 22.8264 17.4793C21.9919 17.4793 21.3161 18.155 21.3161 18.9895V18.1845C21.3161 17.7488 21.1093 17.3648 20.7955 17.11C20.5592 16.9217 20.2601 16.7999 19.9351 16.7999C19.6102 16.7999 19.3185 16.918 19.0822 17.1026C18.7646 17.3537 18.5542 17.7414 18.5542 18.1845V19.3292C18.5542 18.539 17.9117 17.8965 17.1215 17.8965C16.9442 17.8965 16.7818 17.9335 16.6267 17.9888C16.0765 18.1919 15.6851 18.7126 15.6851 19.3292V23.7344H14.1675C14.0456 23.7344 13.9275 23.7491 13.813 23.775C13.0671 23.9374 12.5059 24.5984 12.5059 25.396V26.6477C12.5059 27.2496 12.7533 27.8256 13.1927 28.2392L16.442 31.3113C16.9258 31.7655 17.199 32.4006 17.199 33.0616V33.9815C17.199 34.5706 17.6766 35.0481 18.2657 35.0481H24.2632C24.8523 35.0481 25.317 34.5618 25.4786 33.9953C25.6618 33.3529 26.0054 32.7592 26.4598 32.2492C26.6518 32.0351 26.7884 31.7286 26.7884 31.2929Z",
    fill: "white",
    stroke: "#228C80",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5559 19.329V21.1827",
    stroke: "#228C80",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3163 18.9894V21.1828",
    stroke: "#228C80",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3413 19.6467V21.1828",
    stroke: "#228C80",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6851 23.7343V26.463",
    stroke: "#228C80",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCompresiones);
export default __webpack_public_path__ + "static/media/Ic_compresiones.01f59c1ebc38b59d8a1d29c2a891c153.svg";
export { ForwardRef as ReactComponent };